import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { CreateWorkflowHubPage } from './CreateWorkflowHubPage';

const CreateWorkflowHubPageBridge = react2angular(CreateWorkflowHubPage, []);
export { CreateWorkflowHubPageBridge };
